import React from 'react';
import {meanBy} from 'lodash';

export const getFilters = (state) => {
  const {saleTypeFilter, dateTypeFilter, chassisFilter, reservedToFilter,
    startDateFilter, endDateFilter} = state;
      
  const filters = {
    'saleType': saleTypeFilter,
    'dateType': dateTypeFilter,
    'chassis': chassisFilter,
    'reservedTo': reservedToFilter,
    'startDate': startDateFilter,
    'endDate': endDateFilter,
  };

  Object.keys(filters).forEach((key) => {
    if (!filters[key]) {
      delete filters[key];
    }
  });

  return filters;
};

export const getDealers = (dealersList) => {
  const list = dealersList
    .map((element) => ({'text': element.name, 'value': element.identification}));
  list.unshift({'text': 'Todos', 'value': 'TODOS'});
  return list;
};

export const getAverage = (field, vehiclesList) => {
  if (!vehiclesList.length) {
    return <h2>--</h2>;
  }
  const average = meanBy(vehiclesList, field);
  return <h2>{average ? average : '0 '}</h2>;
};

